import { TheWestLiveBroadcast } from '@news-mono/web-common'
import React, { FC } from 'react'
import { ThemedRender } from '../../../../__styling/themed-render'
import { StyledBannerImage } from '../TheWestLiveBillboard.styled'

interface TheWestLiveBillboardBannerProps {
    broadcast?: TheWestLiveBroadcast
}

const BillboardBanner: React.FC<{
    bannerFull: any
    bannerFull2x: any
    banner: any
    banner2x: any
    alt: string
}> = ({ bannerFull, bannerFull2x, banner, banner2x, alt }) => (
    <React.Fragment>
        <StyledBannerImage
            className="mobile"
            srcSet={`${banner}, ${banner2x} 2x`}
            src={banner}
            alt={alt}
        />
        <StyledBannerImage
            className="full"
            srcSet={`${bannerFull}, ${bannerFull2x} 2x`}
            src={bannerFull}
            alt={alt}
        />
    </React.Fragment>
)

export const TheWestLiveBillboardBanner: FC<TheWestLiveBillboardBannerProps> =
    ({ broadcast }) => {
        if (broadcast === 'catchup') {
            const catchupBannerFull = require('../assets/catchup_billboard_WideScreen.png')
            const catchupBannerFull2x = require('../assets/catchup_billboard_WideScreen@2x.png')
            const catchupBanner = require('../assets/catchup_billboard_mobile.png')
            const catchupBanner2x = require('../assets/catchup_billboard_mobile@2x.png')
            return (
                <BillboardBanner
                    bannerFull={catchupBannerFull}
                    bannerFull2x={catchupBannerFull2x}
                    banner={catchupBanner}
                    banner2x={catchupBanner2x}
                    alt="Catch-up with Ben O'Shea"
                />
            )
        }

        return (
            <ThemedRender
                perthnow={() => {
                    const bannerFull = require('../assets/pn_billboard_930pxWide_For1350pxWideScreen.png')
                    const bannerFull2x = require('../assets/pn_billboard_930pxWide_For1350pxWideScreen@2x.png')
                    const banner = require('../assets/pn_billboard_banner_default_375.png')
                    const banner2x = require('../assets/pn_billboard_banner_default_375@2x.png')

                    return (
                        <BillboardBanner
                            bannerFull={bannerFull}
                            bannerFull2x={bannerFull2x}
                            banner={banner}
                            banner2x={banner2x}
                            alt="Tune in. We are live!"
                        />
                    )
                }}
                thewest={() => {
                    const bannerFull = require('../assets/billboard_930pxWide_For1350pxWideScreen.png')
                    const bannerFull2x = require('../assets/billboard_930pxWide_For1350pxWideScreen@2x.png')
                    const banner = require('../assets/billboard_banner_default_375.png')
                    const banner2x = require('../assets/billboard_banner_default_375@2x.png')

                    return (
                        <BillboardBanner
                            bannerFull={bannerFull}
                            bannerFull2x={bannerFull2x}
                            banner={banner}
                            banner2x={banner2x}
                            alt="Tune in. We are live!"
                        />
                    )
                }}
            />
        )
    }
TheWestLiveBillboardBanner.displayName = 'TheWestLiveBillboardBanner'
export default TheWestLiveBillboardBanner
